import { tabIndexes } from '../../agent-production/helpers/agentProductionHelpers';
import { growthAnalysisIncDecTimeFrame, producerOptions, tabs, allViewOptions } from '../../agent-production/constants/suggestedAgents';
import { agentProductionTerms, initialOptionalFilterTitles, modules, searchTerms } from '../../constants';
import { showOptions, types, viewOptions } from '../../agent-production/constants/savedAgents';
import { filterValues } from '../../agent-production/constants/agentMovement';
import { initialBreakdownState } from '../../agent-production/constants/breakdowns';
import { viewHideAgentsDropdownLabels } from "../../agent-production/constants/agentProductionConstants";


const persistedProfMetricsView = ({
    currentTab: tabIndexes.OVERVIEW,
});

const transactionsSearchView = (initialView) => ({
    ...initialView,
    ...persistedProfMetricsView,
    id: modules.proficiencyMetrics.transactions,
    selectedPropTypes: [],
    selectedMarketAreaList: undefined,
    selectedViewHideAgentsFilter: viewHideAgentsDropdownLabels.viewHideAgents,
    marketAreaTitle: {
        mainTitle: searchTerms.selectType(searchTerms.marketArea)
    },
    propertyTypeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.propertyTypes)
    },
    totalVolumeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.totalVolume)
    },
    soldPriceRangeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.soldPriceRange)
    },
    totalUnitsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.totalUnits)
    },
    bedroomsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.bedrooms)
    },
    fullBathroomsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.fullBathrooms)
    },
    searchFilters: [
        searchTerms.savedSearchFilter,
        searchTerms.mlsFilter,
        searchTerms.marketAreaFilter,
        searchTerms.propTypeFilter,
        searchTerms.timeFrameFilter
    ],
});

const officeSearchView = (initialView) => ({
    ...initialView,
    ...persistedProfMetricsView,
    id: modules.proficiencyMetrics.offices,
    selectedViewHideAgentsFilter: viewHideAgentsDropdownLabels.viewHideAgents,
    officesTitle: {
        mainTitle: searchTerms.selectType(searchTerms.offices)
    },
    totalVolumeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.totalVolume)
    },
    soldPriceRangeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.soldPriceRange)
    },
    totalUnitsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.totalUnits)
    },
    searchFilters: [
        searchTerms.savedSearchFilter,
        searchTerms.mlsFilter,
        searchTerms.timeFrameFilter,
        searchTerms.officesFilter
    ],
    selectedRowIndex: undefined,
});

const agentSearchView = (initialView) => ({
    ...initialView,
    ...persistedProfMetricsView,
    id: modules.proficiencyMetrics.agents,
    selectedViewHideAgentsFilter: viewHideAgentsDropdownLabels.viewHideAgents,
    agents: [],
    selectedPropTypes: [],
    propertyTypeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.propertyTypes)
    },
    agentsTitle: {
        mainTitle: searchTerms.selectType(searchTerms.agents)
    },
    soldPriceRangeTitle: {
        mainTitle: searchTerms.selectType(searchTerms.soldPriceRange)
    },
    searchFilters: [
        searchTerms.savedSearchFilter,
        searchTerms.mlsFilter,
        searchTerms.propTypeFilter,
        searchTerms.timeFrameFilter,
        searchTerms.agentsFilter
    ],
});

const getTabCommonOptions = tabId => ({
    display: {
        selectedView: producerOptionById[tabId].defaultView,
        selectedAgentsView: showOptions[0],
    },
    producers: producerOptionById[tabId],
    growthAnalysisPeriod: {
        value: agentProductionTerms.last12Months,
    }
});

const producerOptionById = {
    [tabs.topProducers.id]: {
        defaultView: allViewOptions[0],
        lowPos: producerOptions.lowPos[0],
        validationSettings: {},
    },
    [tabs.incProducers.id]: {
        defaultView: allViewOptions[2],
        minGrowth: '10',
        maxGrowth: '',
        timeFrame: producerOptions.timeFrame[0],
        growthTimeFrame: growthAnalysisIncDecTimeFrame[0],
        validationSettings: {},
    },
    [tabs.decProducers.id]: {
        defaultView: allViewOptions[2],
        minGrowth: '10',
        maxGrowth: '',
        timeFrame: producerOptions.timeFrame[0],
        growthTimeFrame: growthAnalysisIncDecTimeFrame[0],
        validationSettings: {},
    },
    [tabs.newProducers.id]: {
        defaultView: allViewOptions[0],
        newProd: producerOptions.newProd[1],
        inactivity: producerOptions.inactivity[1],
        validationSettings: {},
    },
    [tabs.coopAgents.id]: {
        defaultView: allViewOptions[0],
        timePeriod: producerOptions.timePeriod[0],
        validationSettings: {},
    }
};

const suggestedAgentsSearchView = (initialView) => ({
    ...initialView,
    currentTabIndex: tabs.topProducers.index,
    currentTabId: Object.values(tabs)[tabs.topProducers.index].id,
    id: modules.proficiencyMetrics.suggestedAgents,
    selectedPropTypes: [],
    selectedMarketAreaList: undefined,
    searchFilters: [
        searchTerms.mlsFilter,
    ],
    searchOptions: {
        topProducers: { ...getTabCommonOptions(tabs.topProducers.id) },
        incProducers: { ...getTabCommonOptions(tabs.incProducers.id) },
        decProducers: { ...getTabCommonOptions(tabs.decProducers.id) },
        newProducers: { ...getTabCommonOptions(tabs.newProducers.id) },
        coopAgents: { ...getTabCommonOptions(tabs.coopAgents.id) },
    },
    selectedAgentIdsByTab: {},
});

const persistedAgentMovementView = ({
    breakdowns: initialBreakdownState,
});

const agentMovementSearchView = (initialView) => ({
    ...initialView,
    ...persistedAgentMovementView,
    id: modules.proficiencyMetrics.agentMovement,
    officesTitle: {
        mainTitle: searchTerms.selectType(searchTerms.offices)
    },
    searchFilters: [
        searchTerms.savedSearchFilter,
        searchTerms.mlsFilter,
        searchTerms.officesFilter,
    ],
    search: {
        ...initialView.search,
        searchCriteria: {criteria: {timePeriod: { intervalType: filterValues.last365Days }}}
    },
})

const savedAgentsSearchView = (initialView) => ({
    ...initialView,
    ...persistedProfMetricsView,
    id: modules.proficiencyMetrics.savedAgents,
    selectedPropTypes: [],
    selectedMarketAreaList: undefined,
    selectedView: viewOptions[0],
    selectedListByModule: {
        [modules.proficiencyMetrics.agents]: undefined,
        [modules.proficiencyMetrics.savedAgents]: undefined,
    },
    agentList: undefined,
    propertyTypeNames: [],
    isLoading: false,
    agentListsCheckedValues: {},
    popoverDataForAddAgentList: {},
    ...initialOptionalFilterTitles,
    searchFilters: [
        searchTerms.savedSearchFilter,
        searchTerms.mlsFilter,
        searchTerms.marketAreaFilter,
        searchTerms.propTypeFilter,
        searchTerms.timeFrameFilter
    ],
    selectedViewHideAgentsFilter: types.SHOW_ALL_AGENTS,
});

export {
    agentSearchView,
    officeSearchView,
    suggestedAgentsSearchView,
    transactionsSearchView,
    agentMovementSearchView,
    savedAgentsSearchView,
};
